import { StepLabel as StepLabelBase } from './StepLabel';
import { StepLabelCss as EmoStepLabel, StepIconCss as EmoStepIcon } from './style';

const styledComponents = {
  StepLabelComp: EmoStepLabel,
  StepIconComp: EmoStepIcon
};

export const StepLabelStyled = props => <StepLabelBase components={styledComponents} {...props} />;

StepLabelStyled.displayName = 'StepLabelStyled';
